// extracted by mini-css-extract-plugin
export default {"reading":"AddReading_reading__AHv-7","campos":"AddReading_campos__a3k33","botao":"AddReading_botao__HFM0m"};